import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingCardBlocked = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="240"
        height="197"
        viewBox="0 0 240 197"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M169.287 7.15955C197.325 11.1345 232.503 26.234 238.891 48.4761C245.282 70.7762 222.896 100.164 201.586 123.677C180.283 147.244 160.075 164.939 135.318 176.861C110.564 188.731 81.3143 194.913 61.6275 183.717C41.9951 172.6 31.9934 144.134 20.3447 119.065C8.65851 93.9414 -4.69858 72.1591 1.62774 56.8893C7.96769 41.6775 33.9911 32.9748 53.5656 27.5011C73.1401 22.0274 86.2079 19.7214 103.251 15.055C120.235 10.3273 141.192 3.18458 169.287 7.15955Z"
          fill="#F9F9F9"
        />
        <rect
          x="62.1855"
          y="58"
          width="116.981"
          height="80.4242"
          rx="12"
          fill="#006DFF"
        />
        <rect
          x="62.1821"
          y="74.8125"
          width="116.981"
          height="13.1603"
          fill="#E8F0FF"
        />
        <rect
          x="79.7295"
          y="100.199"
          width="40.9432"
          height="5.11791"
          rx="2.55895"
          fill="#E8F0FF"
        />
        <path
          d="M211.5 98.5C211.5 148.758 170.758 189.5 120.5 189.5C70.2421 189.5 29.5 148.758 29.5 98.5C29.5 48.2421 70.2421 7.5 120.5 7.5C170.758 7.5 211.5 48.2421 211.5 98.5Z"
          stroke="#E90200"
          strokeWidth="15"
        />
        <path d="M185.5 32L53.5 164" stroke="#E90200" strokeWidth="15" />
      </svg>
    );
  }
);
export default BillingCardBlocked;
